// extracted by mini-css-extract-plugin
module.exports = {"SideBar":"SideBar_SideBar__int39"};